// import "../../../src/App.css";
import Profile from "../../components/Profile/Profile";
import AddProfile from "../../components/AddProfile/AddProfile";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import EmployeeList from "../../components/EmployeeList/EmployeeList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PaginationLink from "../../components/Pagination/Pagination";
import AddFrieghtChargesDomestic from "../../components/AddFrieghtChargesDomestic/AddFrieghtChargesDomestic";
import AirFrieghtDomestic from "../../components/AirFrieghtDomestic/AirFrieghtDomestic";
import AirFrieghtDomesticList from "../../components/AirFrieghtDomesticList/AirFrieghtDomesticList";


function AirFrieghtDomesticMaster() {
  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [filterCityData, setFilterCityData] = useState(false);
  const [selectedTseedID, setSelectedTseedID] = useState('');
  const baseAPI = process.env.REACT_APP_API_URL;
  const title = "Add Air Frieght";
  const heading = "Air Frieght Charges Domestic";

  function tokenStorage(){
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(`${baseAPI}userget/GetAirFreightDomestic?Tseed=0&Origin_Code=&Destination_Code=&Lane=`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {         
          setUserDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }

    if (openAddProfile) {
      setOpenProfile(false);
    }
    else if (openProfile) {
      setOpenAddProfile(false);
    }
  };

  useEffect(() => {
    tokenStorage();

  }, [successMessage, openAddProfile, setOpenProfile, openProfile, setOpenAddProfile]);

  //console.log(userDetailResponse);
  const GetId = (param) => {
    setSelectedTseedID(param);

  };

  // const getTseed = (param) = {
  //   setTseed(param);  }

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4", width:"95%" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Air Frieght Master Domestic | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Master</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <MasterTopButtons
                  title={title}
                  heading={heading}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}
                  setOpenProfile = {setOpenProfile}
                  setFilterCityData = {setFilterCityData}
                  filterCityData = {filterCityData}
                />
                {/* {openAddProfile ? <AddProfile tokenStorage = {tokenStorage} openAddProfile = {openAddProfile} setOpenAddProfile = {setOpenAddProfile} successMessage={successMessage} setSuccessMessage={setSuccessMessage} /> : null}
                {openProfile ? <Profile tokenStorage = {tokenStorage} openProfile = {openProfile} setOpenProfile = {setOpenProfile} selectedEmployeeId={selectedEmployeeId} successMessage={successMessage} setSuccessMessage={setSuccessMessage} /> : null} */}



               {openAddProfile ?  <AddFrieghtChargesDomestic tokenStorage = {tokenStorage} openAddProfile = {openAddProfile} setOpenAddProfile = {setOpenAddProfile} successMessage={successMessage} setSuccessMessage={setSuccessMessage}/> : null}
               {openProfile ? <AirFrieghtDomestic tokenStorage = {tokenStorage} openProfile = {openProfile} setOpenProfile = {setOpenProfile} selectedTseedID={selectedTseedID} setSuccessMessage={setSuccessMessage} /> : null}

            
                <AirFrieghtDomesticList
                  userDetailResponse={userDetailResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={(param) => GetId(param)}
                  openAddProfile = {openAddProfile} 
                  setOpenAddProfile = {setOpenAddProfile}
                />
                               <PaginationLink />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AirFrieghtDomesticMaster;
